import React from 'react';
import styles from './StatsSection.module.css';

const StatsSection = () => {
  return (
    <section className={styles.stats}>
      <div className={styles.container}>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>🏡</div>
          <div className={styles.statNumber}>100%</div>
          <div className={styles.statLabel}>Homemade Food</div>
          <div className={styles.statLabelGuj}>ઘરેલું બનાવટ</div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>🥗</div>
          <div className={styles.statNumber}>Fresh</div>
          <div className={styles.statLabel}>Made Daily</div>
          <div className={styles.statLabelGuj}>રોજ તાજું</div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.statIcon}>🌿</div>
          <div className={styles.statNumber}>Pure</div>
          <div className={styles.statLabel}>Quality Ingredients</div>
          <div className={styles.statLabelGuj}>શુદ્ધ સામગ્રી</div>
        </div>

       <div className={styles.statCard}> <div className={styles.statIcon}>🍛</div> <div className={styles.statNumber}>50+</div> <div className={styles.statLabel}>Varieties</div> <div className={styles.statLabelGuj}>વેરાયટી</div> </div>

      </div>
    </section>
  );
};

export default StatsSection;
